<template lang="pug">
  .customize-your-kit.clearfix.xs-f-small.max-at-tweak
    .xs-12
      SectionTitle.text-center(text="Customize Your Kit" data-mr-ass="customize-kit")

    .xs-12(v-if="boostRecommendations && selectedBoost")
      .nav-wrap.xs-12
        CenterSelectedNav(:labels="boostRecommendationLabels" :value="selectedBoostIndex" @input="updateSelectedBoost")

      .boost-wrap.xs-12
        .boost-image-wrap(:class="boostImgClasses")
          .boost-image.full-width.xs-12.md-6.md-offset-6(v-if="selectedBoost && selectedBoost.imagery")
            img.full-width(:src="selectedBoost.imagery.standard.url" :alt="selectedBoost.imagery.standard.alt_text")
            p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-if="selectedBoost.inventory_status == 'coming_soon'") coming soon
            p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="selectedBoost.inventory_status == 'backordered'") backordered
            p.ribbon.purple.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="selectedBoost.new") new

        .xs-12.md-6(v-if="!showOptions")
          .info-wrap.xs-12.text-center
            .boost-info.xs-12.xs-text-left.md-text-center
              p.boost-name.upper.bold.xs-f-small.lg-f-large.max-at-tweak {{ selectedBoost.name }}
                span.ml-15 {{ selectedBoost.price | currency }}

              button.whats-btn.block.btn-reset.color-purple.xs-f-xsmall.lg-f-small.max-at-tweak.clickable(type="button" @click="showBoostModal()") What's a boost?

          .boost-cta.text-center
            template(v-if="selectedBoost.inventory_status == 'active'")
              .xs-12.sm-10.sm-offset-1.info-box.text-center.xs-f-xsmall.lg-f-small.max-at-tweak(v-if="selectedBoostInNextShipment" data-mr-ass="verify-in-next-shipment")
                i.icon-check
                span This item is in your
                  button.btn-link(@click="$root.scrollTo('#next-shipment', 600, 200)").ml-5.underline next shipment

              button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(v-else @click="openShipmentOptions()" data-mr-ass="add-to-shipment") add to next shipment

            template(v-if="(selectedBoost.inventory_status == 'coming_soon' || selectedBoost.inventory_status == 'backordered') && !onBoostWaitlist")
              button.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(@click="addBoostToWaitlist()") be the first to know

            template(v-else-if="selectedBoost.inventory_status != 'active' && onBoostWaitlist")
              .on-waitlist.text-left
                p.on-waitlist-text.xs-f-small.lg-f-medium.max-at-tweak
                  | We'll email you when this item becomes available
                  span.icon-email.xs-f-xmedium.lg-f-large.max-at-tweak

        .boost-sub-wrap.xs-9.md-6(v-if="showOptions")
          .xs-12.xs-text-left
            p.boost-name.upper.bold.xs-f-small.lg-f-large.max-at-tweak {{selectedBoost.name}}
            Pill(text="1 for $5 or 4 for $16" variant="info").price-pill
            button.whats-btn.block.btn-reset.color-purple.xs-f-xsmall.lg-f-small.max-at-tweak.clickable(type="button" @click="showBoostModal()") What's a boost?

        .ship-wrap.xs-12.md-6(v-if="showOptions")
          .ship-qty
            span.xs-f-xsmall.max-at-tweak.upper qty:
            QtyButtons(:qty="selectedBoostQty" @qtyChange="onQtyChange")

          ProductShipOptions(v-model="subscribeToBoost")

          .boost-cta.xs-text-center.md-text-left
            .info-box.text-center.xs-f-xsmall.lg-f-small.max-at-tweak(v-if="selectedBoostInNextShipment")
              i.icon-check
              span This item is in your next shipment

            button(v-else @click="addBoost" :class="{ disabled: modifyingRefillProduct || savingSub }" data-mr-ass="add-every-shipment").mr-btn.xs-f-xsmall.max-at-tweak {{ addButtonText }}
              span ({{ selectedBoostPriceTotal | currency }})

            transition(name="fade")
              .savings-indicator.color-green.xs-f-small.lg-f-medium.max-at-tweak(v-if="combinedBoostQty > 3")
                i.icon-check.mr-5
                span 4 Boosts for $16—such a great choice

</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
  import SectionTitle from "../../../SectionTitle";
  import CenterSelectedNav from "../../../CenterSelectedNav";
  import boostMixin from "../../../../mixins/boostMixin.js";
  import Pill from "../../../Pill";
  import QtyButtons from "../../../QtyButtons";
  import MrRadio from "../../../mrRadio";
  import ProductShipOptions from "../../../NextOrEveryOrder/ProductShipOptions";

  export default {
    name: "CustomizeYourKit",

    components: {
      ProductShipOptions,
      MrRadio,
      QtyButtons,
      Pill,
      SectionTitle,
      CenterSelectedNav
    },

    mixins: [ boostMixin ],

    data() {
      return {
        ctaSource: 'Customize Your Kit'
      }
    },

    mounted() {
      if (this.$route.hash) {
        setTimeout(() => {
          this.$root.scrollTo(this.$route.hash);
        }, 2000); //- long timeout is necessary so that all sections are loaded before scroll starts
      }
    },

    computed: {
      ...mapState('refillCart', [
        'modifyingRefillProduct'
      ]),

      ...mapState('subscriptions', [
        'savingSub'
      ]),

      ...mapGetters('refillCart', ['qtyByProductTypeInRefillCart']),

      boostImgClasses() {
        let classes = ['xs-12', 'md-6'];
        if (this.showOptions) {
          classes = ['xs-3', 'sm-3', 'md-6', 'showing-options'];
        }

        return classes;
      },

      selectedBoostQty: {
        get() {
          return this.selectedBoost.qty;
        },

        set(val) {
          this.setBoostQty(val);
        }
      },

      subscribeToBoost: {
        get() {
          return this.selectedBoost.subscribe;
        },

        set(val) {
          this.setBoostSubscription(val);
        }
      },

      boostRefillCartQty() {
        return this.qtyByProductTypeInRefillCart('boosts');
      },

      combinedBoostQty() {
        return this.boostRefillCartQty + this.selectedBoostQty;
      },

      selectedBoostPriceTotal() {
        let total = 0;

        for(var i = 1; i <= this.selectedBoostQty; i++) {
          if ((i + this.boostRefillCartQty) % 4) {
            total += this.selectedBoost.price;
          } else {
            total += 1;
          }
        }

        return total;
      },

      addButtonText() {
        return `Add to ${this.subscribeToBoost ? "Every" : "Next"} Shipment `;
      }
    },

    methods: {
      ...mapMutations('xsell', [
        'setBoostQty',
        'setBoostSubscription'
      ]),

      ...mapActions('subscriptions', [
        'addSubAttachment'
      ]),

      ...mapActions('refillCart', [
        'addToRefillCart',
        'loadRefillCart',
        'initRefillCart'
      ]),

      showBoostModal() {
        this.$store.dispatch('modal/showModal', { component: './Dashboard/Welcome/ReturnCustomer/BoostModal', theme: 'no-padding' }, { root: true });
      },

      onQtyChange(qty) {
        this.setBoostQty(qty);
      },

      addBoost() {
        if (this.selectedBoost.subscribe) {
          let payload = {
            sub_id: this.refillCart.nextShipment.sub_id,
            product_id: this.selectedBoost.id,
            qty: this.selectedBoost.qty,
            ctaSource: this.ctaSource
          };

          this.addSubAttachment(payload).finally(this.loadRefillCart);
        } else {
          if (!this.selectedBoostInNextShipment) {
            this.addToRefillCart({
              product_id: this.selectedBoost.id,
              qty: this.selectedBoost.qty,
              ctaSource: this.ctaSource
            });
          }
        }
      }
    },

    mounted() {
      this.initRefillCart();
    }
  }
</script>

<style scoped lang="stylus">
  .customize-your-kit
    .section-title
      padding 1em

    .boost-wrap
      padding 2em 1em

      .info-box
        padding 1em 0.2em
        background-color #e6eef6

        i
          padding-right 0.5em

    .boost-image-wrap
      &.showing-options
        margin-bottom 1em

      .boost-image
        position relative
        overflow hidden

        img
          vertical-align middle

        .ribbon
          position absolute
          transform translate3D(-50%, -50%, 0) rotate(-45deg)
          top 4em
          left 4em
          background-color #d8e3f2
          padding 0.5em 3em
          min-width 15em
          text-align center

          &.purple
            background-color color-mr-purple
            color color-white

    .info-wrap
      padding 2.5em 0 0 0

      .whats-btn
      .mr-btn
        display block
        margin 0 auto
        vertical-align middle

      .whats-btn
        display block
        margin 1em auto
        padding 1em

      .on-waitlist
        width 100%
        padding 1.5em 25%
        background-color #e6eef6

        .on-waitlist-text
          position relative

          .icon-email
            position absolute
            top -0.25em
            left -2em

    .boost-sub-wrap
      padding 0 1em

      .price-pill
        padding 0.5em 1em
        margin 1em 0em

      .whats-btn
        margin-bottom 1em

    .ship-wrap
      .ship-qty
        padding 1em 0.5em
        border-top 1px solid color-fog-light
        border-bottom 1px solid color-fog-light

        > span
          padding-right 1.5em

    .savings-indicator
      padding-top 1em

    @media mq-mobile
      .boost-image-wrap
        padding 0 3.5em

        &.showing-options
          padding 0

      .boost-info
        padding 0 12%

      .info-wrap
        padding 1.5em 0 0 0

        .boost-info
          padding 0 3.5em

        .whats-btn
          margin-top 0
          margin-left 0
          padding-left 0

        .on-waitlist
          padding 1.5em 15%

    @media mq-tablet
      .boost-image-wrap
        padding 0 3.5em

        &.showing-options
          padding 0

      .boost-info
        padding 0 10%

      .info-wrap
        padding 1.5em 0 0 0

        .boost-info
          padding 0 3.5em

        .whats-btn
          margin-top 0
          margin-left 0
          padding-left 0

        .on-waitlist
          padding 1.5em 20%

    @media mq-desktop-md-plus
      .nav-wrap
        float right

      .boost-sub-wrap
      .ship-wrap
        padding 0 2em

        .ship-qty
          max-width 20em

    @media mq-desktop-md
      .boost-sub-wrap
      .ship-wrap
        padding 0 2em

        .ship-qty
          max-width 20em

      .info-wrap
        padding 3em 0 0 0

        .on-waitlist
          padding 1.5em 20%

</style>
